import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import App from './App';
import ErrorBoundary from '@/entities/ErrorBoundary/global';
Sentry.init({
    dsn: "https://3fa9259b8210d139dfe99a465503129c@o4509637489328128.ingest.de.sentry.io/4509637659787344",
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
    _experiments: { enableLogs: true },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(BrowserRouter, { children: _jsx(ErrorBoundary, { children: _jsx(App, {}) }) }));
